/**
 * Единая точка доступа к контракту @parkline/shared для веб-клиента.
 *
 * ЗАЧЕМ ЭТОТ ФАЙЛ: packages/shared/dist собран в CommonJS (barrel через
 * __exportStar), а браузер такой модуль не исполняет. Прямой
 * `import { can } from '@parkline/shared'` в веб-коде даёт:
 *   - dev: «ReferenceError: exports is not defined» и белый экран целиком
 *     (Vite не пребандлит symlink-пакет воркспейса);
 *   - build: «"can" is not exported by packages/shared/dist/index.js» — Rollup
 *     не видит именованные экспорты сквозь __exportStar.
 * Поэтому значения берём из TypeScript-исходников пакета (нормальный ESM,
 * Vite компилирует их сам) и реэкспортируем здесь одним списком.
 *
 * Типы можно импортировать и напрямую из '@parkline/shared' — они стираются при
 * компиляции и на сборку не влияют.
 *
 * УБРАТЬ, когда packages/shared начнёт отдавать ESM (dual-сборка или
 * optimizeDeps.include в vite.config.ts): тогда достаточно обычных именованных
 * импортов из '@parkline/shared'.
 */
import * as shared from '@parkline/shared/src/index';

export const {
  // роли и права
  ROLES,
  ROLE_LABELS,
  PERMISSIONS,
  ROLE_PERMISSIONS,
  can,
  // стартовый раздел по правам роли
  landingPath,
  FALLBACK_LANDING,
  // статусные модели
  RELEASE_STATUSES,
  ASSIGNMENT_STATUSES,
  SHIFT_STATUSES,
  WAYBILL_STATUSES,
  INTEGRATION_STATES,
  SHIFT_STATUS_LABELS,
  WAYBILL_STATUS_LABELS,
  INTEGRATION_STATE_LABELS,
  // что стало с подписью у ЕСУТД
  SIGNATURE_DELIVERY_LABELS,
  // готовность смены к выпуску
  READINESS_CONDITIONS,
  READINESS_LABELS,
  // контракт ЕСУТД
  ESUTD_TRANSPORTATION_TYPE,
  ESUTD_CARRIER_TYPE,
  ESUTD_STAGES,
  ESUTD_CHAIN_STAGES,
  ESUTD_STAGE_LABELS,
  ESUTD_PROGRESS_LABELS,
  ESUTD_DOCUMENT_STATUS_LABELS,
  esutdSyncLabel,
  esutdCallCount,
  reconcileStage,
  examResultSchema,
  // Тела стадий: конвертных схем (transRoute/carrier/mechanic/...) в контракте ЕСУТД
  // не существует — тела плоские, по одному на метод.
  createWaybillPassengerSchema,
  medicalExaminationSchema,
  technicalInspectionPreTripSchema,
  technicalInspectionPostTripSchema,
  signWaybillSchema,
  confirmReadingSchema,
  returnDateTimeSchema,
} = shared;

export type {
  ApiEnvelope,
  AssignmentStatus,
  ConfirmReading,
  CreateWaybillPassenger,
  EsutdDocumentStatus,
  EsutdExamResult,
  EsutdProgressStatus,
  EsutdReconcileVerdict,
  EsutdStage,
  IntegrationState,
  MedicalExamination,
  PageMeta,
  Paged,
  Permission,
  Readiness,
  ReadinessCondition,
  ReleaseStatus,
  ReturnDateTime,
  Role,
  ShiftStatus,
  SignWaybill,
  TechnicalInspectionPostTrip,
  TechnicalInspectionPreTrip,
  WaybillStatus,
} from '@parkline/shared';
